"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let SafetyDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.application_guid = "";
    this.device_code = "";
    this.device_name = "";
    this.ip = "";
    this.status = "";
    this.handle_time = 0;
    this.applicant = "";
    this.marks = [];
    this.authorize_method = {};
    this.network_mac_all = [];
  }
};
SafetyDetailModel.model = "authorize.application.detail";
SafetyDetailModel = __decorateClass([
  Annotation.ModelMeta
], SafetyDetailModel);
